/* Model rail colour swatches.

   Delegated from the document, so it costs one listener no matter how many rails
   or cards a page has, and cards re-rendered by the theme editor keep working
   without re-binding.

   The swap is deliberately not a cross-fade between two stacked images. Holding
   every colour in the DOM is what the colour lab does, but that section shows one
   product; this rail shows five cards and iPhone 17 alone has twenty-two colours,
   so stacking would put a hundred renders on the homepage. There is one <img> per
   card and its source is swapped, with the cost paid down by preloading on hover:
   by the time a dot is clicked the bytes are usually already cached, and a short
   dip in opacity covers whatever is left.

   THE SWAP CANNOT BE LEFT HANGING. The first version waited on Image.decode()
   before swapping, and on a detached image carrying a srcset that promise never
   settled — the card faded out and stayed blank, with the old render still in
   place underneath. Nothing about a decorative colour swap is worth a blank card,
   so the swap now runs on whichever comes first: the preload finishing, or a
   deadline. It runs exactly once either way.

   Clicking a dot also retargets the card's link, so the shopper lands on the PDP
   on the colour they were just looking at rather than back on the default. */
(function () {
  'use strict';

  if (window.__sutiModelRail) return;
  window.__sutiModelRail = true;

  var FADE = 150;      /* how long the dip lasts before the new render lands */
  var DEADLINE = 700;  /* swap regardless by here, cached or not */

  function preload(dot) {
    if (!dot || dot.dataset.pre) return;
    dot.dataset.pre = '1';
    var i = new Image();
    if (dot.dataset.srcset) i.srcset = dot.dataset.srcset;
    i.src = dot.dataset.img;
  }

  function select(dot) {
    var card = dot.closest('[data-smr-card]');
    if (!card) return;

    card.querySelectorAll('[data-smr-dot]').forEach(function (d) {
      var on = d === dot;
      d.classList.toggle('is-on', on);
      d.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var link = card.querySelector('[data-smr-link]');
    if (link && dot.dataset.href) link.setAttribute('href', dot.dataset.href);

    var img = card.querySelector('[data-smr-img]');
    if (!img || !dot.dataset.img || img.getAttribute('src') === dot.dataset.img) return;

    var token = (card.dataset.smrToken = String(Date.now()));
    var swapped = false;

    function swap() {
      if (swapped) return;
      swapped = true;
      /* A faster click may have started a newer swap; that one owns the image. */
      if (card.dataset.smrToken !== token) return;
      img.src = dot.dataset.img;
      if (dot.dataset.srcset) img.srcset = dot.dataset.srcset;
      if (dot.dataset.name) img.alt = dot.dataset.name;
      img.classList.remove('is-fading');
    }

    img.classList.add('is-fading');

    var loaded = false;
    var elapsed = false;
    var ready = function () { if (loaded && elapsed) swap(); };

    var next = new Image();
    next.onload = next.onerror = function () { loaded = true; ready(); };
    if (dot.dataset.srcset) next.srcset = dot.dataset.srcset;
    next.src = dot.dataset.img;
    /* A cached image can be complete before the handlers are attached. */
    if (next.complete) loaded = true;

    setTimeout(function () { elapsed = true; ready(); }, FADE);
    setTimeout(swap, DEADLINE);
  }

  document.addEventListener('click', function (e) {
    var more = e.target.closest && e.target.closest('[data-smr-more]');
    if (more) {
      e.preventDefault();
      var row = more.closest('[data-smr-sw]');
      if (row) {
        row.querySelectorAll('.is-extra').forEach(function (d) { d.classList.remove('is-extra'); });
      }
      more.remove();
      return;
    }

    var dot = e.target.closest && e.target.closest('[data-smr-dot]');
    if (!dot) return;
    /* The card link's ::after covers the card, so stop this reaching it. */
    e.preventDefault();
    e.stopPropagation();
    select(dot);
  });

  /* pointerenter does not bubble; pointerover does. */
  document.addEventListener('pointerover', function (e) {
    var dot = e.target.closest && e.target.closest('[data-smr-dot]');
    if (dot) preload(dot);
  }, { passive: true });

  /* Keyboard users never hover, so warm the image when a dot takes focus. */
  document.addEventListener('focusin', function (e) {
    var dot = e.target.closest && e.target.closest('[data-smr-dot]');
    if (dot) preload(dot);
  });
})();
